import { render, staticRenderFns } from "./relationCourseList.vue?vue&type=template&id=0eeb5930&scoped=true"
import script from "./relationCourseList.vue?vue&type=script&lang=js"
export * from "./relationCourseList.vue?vue&type=script&lang=js"
import style0 from "./relationCourseList.vue?vue&type=style&index=0&id=0eeb5930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeb5930",
  null
  
)

export default component.exports